<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <p-table
      #dt
      [value]="suppliers"
      [rows]="10"
      [paginator]="true"
      [loading]="isLoading"
      [lazy]="true"
     
      dataKey="id"
      styleClass="p-datatable-striped md-data-table"
    >
      <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Suppliers</h2>

          <div class="ml-auto">
            <p-button
              label="New Supplier"
              icon="pi pi-plus"
              (onClick)="createSupplier()"
            ></p-button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="supplierName">
            Supplier Name <p-sortIcon field="supplierName"></p-sortIcon>
          </th>
          <th pSortableColumn="supplierNumber">
            Supplier Code <p-sortIcon field="supplierNumber"></p-sortIcon>
          </th>
          <th style="width: 10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-supplier>
        <tr>
          <td>{{ supplier.supplierName }}</td>
          <td>{{ supplier.supplierNumber ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editSupplier(supplier.id)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-warning"
                (onClick)="deleteSupplier(supplier.id)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Suppliers found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
